import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  Screen1,
  ForWhom,
  StartNow,
  Structure,
  Efficiency,
  Influence,
  Maintenance,
  Author,
  About,
  Cost,
  Faq,
  Trial
} from "../../../components/LandingTemplates/kak_nauchit_rebenka_chitat";

import { FooterFull } from "../../../components/FooterFull";

const TITLE = 'Онлайн-курс Как научить ребёнка читать быстро и с умом?';
const DESCRIPTION = 'Узнайте, как помочь ребенку читать в 2 раза быстрее и развить память, внимание и мышление.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1/>
      <ForWhom/>
      <StartNow/>
      <Structure/>
      <Efficiency/>
      <Influence/>
      <Maintenance/>
      <Author/>
      <About/>
      <Cost/>
      <Faq/>
      <Trial accessLimited={true}/>
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
